import { OpenSansText } from "@Components/CustomText/OpenSansText"
import React, { useState } from "react"
import { Dimensions, StyleSheet, TouchableOpacity, View } from "react-native"
import { baseColors } from "@Constants/baseStyles"
import { VictoryAxis, VictoryBar, VictoryChart, VictoryContainer, VictoryLine, VictoryTheme } from "victory"
import { useRecoilValue } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import moment from "moment"
import { dbDateFormat } from "@Utils/utils"
import { ActivityIndicator, Text } from "react-native-paper"
import { useNavigation } from "@react-navigation/native"
const { width, hieght } = Dimensions.get("screen")

export const ConstantLineChart = ({ constant }) => {
    const { id, name, categories, data } = constant
    const [loading, setLoading] = useState(false)
    const user = useRecoilValue(userAtom)
    const navigation = useNavigation()

    const categoriesData = Array.from(categories, (category, i) => ({
        date: moment(category, dbDateFormat).format("DD/MM"),
        value: data[i]
    }))

    const isTension = id === 10
    const isCigarette = id === 11
    const series = categoriesData
    // ? categoriesData
    // : categoriesData?.filter((serie) => (isCigarette ? serie?.value !== null : serie?.value > 0))

    const useLineChart = series?.length > 0 && !isTension
    const useSimpleBarChart = series?.length === 1 && !isTension

    const hideChart = series?.every((serie) => serie?.value === null) && !isCigarette

    const yValues = series?.map((serie) => {
        if (serie.value > 0) {
            return +Number(serie.value || 0).toFixed(2)
        }
        return serie.value
    })
    const xValues = series?.map((serie) => serie.date)

    const removeNullValues = series?.filter((serie) => serie?.value !== null && serie?.value !== "")

    const tensionSeries = isTension
        ? removeNullValues?.map((serie) => ({
              x: serie?.date,
              y: isNaN(+serie?.value?.split("/")?.[1]) ? 0 : +serie?.value?.split("/")?.[1],
              y0: isNaN(+serie?.value?.split("/")?.[0]) ? 0 : +serie?.value?.split("/")?.[0]
          }))
        : []

    const hideTensionChart = series?.length === 1 && series?.[0]?.value === ""

    const showZeroChartOnly = series?.length === 1 && series?.[0]?.value === 0

    const handlePress = () =>
        navigation.navigate("ConstantCardDetails", {
            constant
        })

    if (hideChart || (isTension && hideTensionChart)) {
        return null
    }

    return (
        <TouchableOpacity
            onPress={handlePress}
            style={{
                flex: 1,
                marginTop: 20,
                justifyContent: "center",
                alignItems: "center",
                borderRadius: 8,
                padding: 10,
                backgroundColor: baseColors.green.light
            }}
        >
            <OpenSansText style={{ marginTop: 15 }} fontSize={20}>
                {name}
            </OpenSansText>
            {loading ? (
                <View style={{ padding: 40 }}>
                    <ActivityIndicator color={baseColors.orange.primary} />
                </View>
            ) : series?.length > 0 ? (
                useSimpleBarChart ? (
                    <VictoryChart
                        containerComponent={<VictoryContainer disableContainerEvents />}
                        events={[
                            {
                                target: "data",
                                eventHandlers: {
                                    onPress: handlePress
                                }
                            }
                        ]}
                        domainPadding={20}
                        width={350}
                        theme={VictoryTheme.material}
                    >
                        <VictoryBar
                            style={{
                                data: { fill: baseColors.green.primary }
                            }}
                            // events={[
                            //     {
                            //         target: "data",
                            //         eventHandlers: {
                            //             onPressIn: handlePress,
                            //             onPress: handlePress
                            //         }
                            //     }
                            // ]}
                            barWidth={20}
                            data={series}
                            x="date"
                            y="value"
                            tickValues={[2]}
                        />
                        {showZeroChartOnly && <VictoryAxis y0={0} />}
                    </VictoryChart>
                ) : useLineChart ? (
                    <VictoryChart
                        containerComponent={<VictoryContainer disableContainerEvents />}
                        events={[
                            {
                                target: "data",
                                eventHandlers: {
                                    onPress: handlePress
                                }
                            }
                        ]}
                        width={width - 20}
                        theme={VictoryTheme.material}
                    >
                        <VictoryLine
                            scale={{ x: "linear", y: "log" }}
                            interpolation={"linear"}
                            style={{
                                data: { stroke: baseColors.orange.primary }
                            }}
                            x={"date"}
                            y={"value"}
                            data={series}
                        />

                        <VictoryAxis
                            dependentAxis
                            style={{
                                grid: { stroke: "#718096", strokeDasharray: "2 10" },
                                tickLabels: { fontSize: 8 }
                            }}
                            tickValues={yValues}
                        />
                        <VictoryAxis
                            style={{
                                grid: { stroke: "rgba(0,0,0,0)", strokeDasharray: "2 10" },
                                tickLabels: { fontSize: 8 }
                            }}
                            tickValues={yValues}
                        />
                    </VictoryChart>
                ) : (
                    <VictoryChart domainPadding={20} width={width - 20} theme={VictoryTheme.material}>
                        <VictoryBar
                            barWidth={12}
                            style={{
                                data: { stroke: baseColors.orange.primary, fill: baseColors.green.primary }
                            }}
                            categories={{ x: xValues }}
                            data={tensionSeries}
                        />
                    </VictoryChart>
                )
            ) : null}
        </TouchableOpacity>
    )
}
